// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d1799da","455":"c4064aca","977":"36cf3b92"}[chunkId] + ".chunk.js";
};